module.exports = __webpack_public_path__ + "1e21e0fba889b7c9973ff202f158c967.png";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/default-img.png
// module id = 48
// module chunks = 47